import { render, staticRenderFns } from "./AccountSignup.vue?vue&type=template&id=518faca3&scoped=true"
import script from "./AccountSignup.vue?vue&type=script&lang=js"
export * from "./AccountSignup.vue?vue&type=script&lang=js"
import style0 from "./AccountSignup.vue?vue&type=style&index=0&id=518faca3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518faca3",
  null
  
)

export default component.exports